import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { AmountInput } from "./InputAmount";
import { CustomAutoComplete } from "../../../../../../components/input/CustomAutoComplete";
import { useFormContext, FormProvider } from "react-hook-form";
import { AddEmissionContext } from "../../../../../../contexts/AddEmissionContext";

import { common, input } from "../../../../../../i18n";
import { useEffect } from "react";
import { NumericField } from "../../../../../../components/input/NumericField";
import { WASTE_SOURCE_CATEGORY } from "../../../../../../constants";

const AddOutsourcingWasteDisposal = () => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const stepTwoForm = useFormContext();

  const { isDisabledAuxInput, inputAmountType } = AddEmissionContext();

  const wasteConstantValue: number = 1.12;

  const person: string | undefined = stepTwoForm.watch("person");

  const schedule: string | undefined = stepTwoForm.watch("schedule");

  const calculation = (person: number, schedule: number): string => {
    const result = (wasteConstantValue * (person * schedule)) / 1000;

    return result.toFixed(2);
  };

  useEffect(() => {
    const personNumber: number = Number(person);

    const scheduleNumber: number = Number(schedule);
    if (Number.isNaN(personNumber) && Number.isNaN(scheduleNumber)) return;

    stepTwoForm.setValue("amount", calculation(personNumber, scheduleNumber), {
      shouldValidate: true,
    });
  }, [person, schedule]);

  return (
    <FormProvider {...stepTwoForm}>
      <Grid item xs={12} md={6}>
        <AmountInput
          label={t("Amount-Of-Waste")}
          info={t("Amount-Of-Waste")}
          control={stepTwoForm.control}
          disabled={inputAmountType === "special" ? true : false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <CustomAutoComplete
          required={!isDisabledAuxInput}
          label={t("Waste-Type")}
          info={t("Waste-Type")}
          control={stepTwoForm.control}
          name="aux1"
          listMenuItem={WASTE_SOURCE_CATEGORY}
          placeholder={t("Select-Param", {
            param: t("Waste-Type"),
          })}
          rules={
            isDisabledAuxInput
              ? undefined
              : {
                  required: t("This-field-is-required", {
                    param: t("Waste-Type"),
                  }),
                }
          }
          defaultValue={null}
          disabled={isDisabledAuxInput}
        />
      </Grid>

      {inputAmountType === "special" && (
        <>
          <Grid item xs={12} md={6}>
            {/* <InputReactHookForm
              name="person"
              required
              label={t("Person-On-site")}
              info={t("Amount-of-Persons-Description")}
              control={stepTwoForm.control}
              placeholder={t("Person-On-site")}
              defaultValue={""}
              rules={
                isDisabledAuxInput
                  ? undefined
                  : {
                      required: t("This-field-is-required", {
                        param: t("Person-On-site"),
                      }),
                      pattern: {
                        value: NUMBER_ONLY_REGEX,
                        message: t("Specify-Integer-Only"),
                      },
                    }
              }
              disabled={isDisabledAuxInput}
              endIcon={<Typography variant="text1">{t("Person")}</Typography>}
            /> */}
            <NumericField
              required={!isDisabledAuxInput}
              size="small"
              name="person"
              control={stepTwoForm.control}
              allowNegative={false}
              decimalScale={0}
              label={t("Person-On-site")}
              info={t("Amount-of-Persons-Description")}
              placeholder={t("Person-On-site")}
              fullWidth
              disabled={isDisabledAuxInput}
              InputProps={{
                endAdornment: (
                  <Typography variant="text1">{t("Person")}</Typography>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <NumericField
              required={!isDisabledAuxInput}
              size="small"
              name="schedule"
              control={stepTwoForm.control}
              allowNegative={false}
              decimalScale={0}
              label={t("On-site-Schedule")}
              info={t("On-site-Schedule")}
              placeholder={t("On-site-Schedule")}
              fullWidth
              disabled={isDisabledAuxInput}
              InputProps={{
                endAdornment: (
                  <Typography variant="text1">{t("Per-Interval")}</Typography>
                ),
              }}
            />

            {/* <InputReactHookForm
              name="schedule"
              required
              label={t("On-site-Schedule")}
              info={t("On-site-Schedule")}
              control={stepTwoForm.control}
              placeholder={t("On-site-Schedule")}
              defaultValue={""}
              rules={
                isDisabledAuxInput
                  ? undefined
                  : {
                      required: t("This-field-is-required", {
                        param: t("On-site-Schedule"),
                      }),
                      pattern: {
                        value: NUMBER_ONLY_REGEX,
                        message: t("Specify-Integer-Only"),
                      },
                    }
              }
              disabled={isDisabledAuxInput}
              endIcon={
                <Typography variant="text1">{t("Per-Interval")}</Typography>
              }
            /> */}
          </Grid>
        </>
      )}
    </FormProvider>
  );
};

export default AddOutsourcingWasteDisposal;
